import { useEffect } from "react";

export function WordLimitIndicator({ words, limit, setFlag }) {
  useEffect(() => {
    setFlag(Number(limit) - Number(words.length) <= 0 ? false : true);
  }, [words]);

  return (
    <section className="">
      <p
        className={`text-[15px] font-medium ${
          Number(limit) - Number(words.length) <= 0
            ? "text-red-600"
            : "text-blue-600"
        }`}
      >
        {Number(limit) - Number(words.length)}/{limit}
      </p>
    </section>
  );
}
